import { DownArrowIcon } from "@xola/icons";
import { PopoverList, Switch } from "@xola/ui-kit";
import { FormField } from "common";
import { useFormikContext } from "formik";
import React, { useState } from "react";
import { Package, PackageType, Schedule, SelectionState } from "types";
import { TimePickerPopover } from "../../../Common/TimePickerPopover";

export enum StartRestrictionType {
    WITH_IN = "within",
    SAME_DAY = "on the same day",
}

export interface PackageFormValues extends Partial<Package> {
    name: string;
    excerpt: string;
    desc: string;
    seller: {
        id: ID;
    };
    type?: PackageType;
    selectedExperiences: SelectionState;
    selectedPartnerExperiences?: SelectionState;
    minimumTransitDuration: number;
    showStartingRestriction: boolean;
    restrictionDuration: number;
    schedules: Schedule[];
    restrictionType: StartRestrictionType;
    collections?: string[];
}

export const StartTimeRestriction = () => {
    const { values, errors, setFieldValue } = useFormikContext<PackageFormValues>();
    const [visible, setVisible] = useState(false);
    const { showStartingRestriction, restrictionDuration, restrictionType } = values;

    return (
        <FormField
            label="Start time restriction"
            name="startTimeDuration"
            tooltip={
                !showStartingRestriction &&
                "Enable to require events to be restricted to within a certain period of time from one another."
            }
            placement="top"
        >
            <Switch
                isChecked={showStartingRestriction}
                onChange={(value: boolean) => setFieldValue("showStartingRestriction", value)}
            />
            {showStartingRestriction ? (
                <span className="ml-2">
                    Start times for events in package purchases must be{" "}
                    <PopoverList
                        visible={visible}
                        className="max-h-60 !w-40 overflow-y-auto"
                        onClickOutside={() => setVisible(false)}
                    >
                        <span
                            className="inline-flex cursor-pointer items-center underline"
                            onClick={() => setVisible(!visible)}
                        >
                            <span className="font-bold">{restrictionType}</span>
                            <DownArrowIcon size="medium" className="relative top-0.25" />
                        </span>
                        {[StartRestrictionType.WITH_IN, StartRestrictionType.SAME_DAY].map((option) => (
                            <PopoverList.Item
                                key={option}
                                name={option}
                                isActive={option === restrictionType}
                                onClickItem={() => setFieldValue("restrictionType", option)}
                            >
                                <span>{option}</span>
                            </PopoverList.Item>
                        ))}
                    </PopoverList>
                    {restrictionType === StartRestrictionType.WITH_IN && (
                        <>
                            <TimePickerPopover
                                showArrow
                                value={restrictionDuration}
                                isError={!!errors.restrictionDuration}
                                errorMessage={errors.restrictionDuration}
                                onApply={(value) => setFieldValue("restrictionDuration", value)}
                            />
                            of one another
                        </>
                    )}
                </span>
            ) : (
                <span className="ml-2">No restrictions are active</span>
            )}
        </FormField>
    );
};
